import { FormLabel, Grid, MenuItem, Select } from "@mui/material"
import { StringNumber } from "../../types";



export const SelectCamisa = ({ valor: _val, action }: { valor: StringNumber | null, action: any }) => {

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Camisa</FormLabel>
        <Select
          value={_val || 'N/A'}
          onChange={action}
        >
          <MenuItem value={'N/A'}>N/A</MenuItem>
          {
            ['GG', 'G', 'M', 'P', 'PP']
              .map(
                el => <MenuItem value={el}>{el}</MenuItem>
              )
          }
        </Select>
      </Grid>
    </>
  )
}
